import React from 'react';
import { Experience } from '../components/Experience';
import { FinalCTA } from '../components/FinalCTA';
import { PageIntro } from '../components/PageIntro';
import { RetreatSpaceDetails } from '../components/RetreatSpaceDetails';
import { WhatHappensHere } from '../components/WhatHappensHere';
export function RetreatSpacePage() {
  return <>
      <PageIntro eyebrow="Retreat Space" title="Host the next thing that matters." description="Pines Retreat is a nature-based venue for workshops, group retreats, team days, breathwork, yoga, music, and private gatherings." data-id="element-445" data-mp="1gjwaaw607ddu" />
      <Experience data-id="element-446" data-mp="12mg67rb6jvp9" />
      <RetreatSpaceDetails data-id="element-447" data-mp="12nr63g1i8jb3" />
      <WhatHappensHere data-id="element-448" data-mp="12o0xn8276yiw" />
      <FinalCTA data-id="element-449" data-mp="xvrb820akgld" />
    </>;
}